import { css, excludeProps, GridCol, GridContainer, GridRow, mixins, styled } from '@bob/library'
import { GatsbyLinkProps, Link } from 'gatsby'
import { FC } from 'react'

export interface RegionItemProps {
  isRtl?: boolean
}

export const Wrapper = styled(GridContainer)``

export const Title = styled.h2`
  ${mixins.typography.headlineLarge}
  ${mixins.margin.bottom(30)}
`

export const LangImg = styled.img`
  width: 24px;
`

export const RegionsWrapper = styled(GridRow)``

export const RegionItemWrapper = styled(GridCol)`
  ${mixins.padding(20, 0)};
`

export const RegionItem = styled(
  excludeProps(Link as unknown as FC<GatsbyLinkProps<any>>, 'isRtl')
)<RegionItemProps>`
  display: flex;
  align-items: center;
  & > img {
    margin-right: ${({ isRtl }: RegionItemProps) => (isRtl ? 0 : '15px')};
    margin-left: ${({ isRtl }: RegionItemProps) => (isRtl ? '15px' : 0)};
  }
  ${({ isRtl }: RegionItemProps) =>
    isRtl
      ? css`
          direction: rtl;
          float: left;
        `
      : css``}
`

export const RegionImg = styled.img`
  width: 50px;
`

export const ButtonTertiary = styled.button`
  ${mixins.cta.tertiary('black')}
`
